export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const MINSIDE_FRONTEND_VERSION = '13.04.2026T11:17:30';

export const PAYMENT_METHODS = {
  'NONE': 0,
  'INVOICE': 1,
  'STRIPE': 2,
  'STREX': 3,
};

export const SUBSCRIPTION_STATES = {
  'INACTIVE': 0,
  'READY': 1,
  'ACTIVE': 2,
  'CANCEL_AT_PERIOD_END': 3,
  'CANCELED': 4,
};

const ENV = process.env.MAB_ENV || 'development';


export const BACKEND_BASE_URL = ENV === 'development'
  ? 'http://localhost:7000/api'
  : ENV === 'staging'
    ? 'https://app.beta.medarbeiderne.no/api'
    : 'https://app.medarbeiderne.no/api';

export const WORDPRESS_URL = ENV === 'production'
  ? 'https://medarbeiderne.no'
  : 'https://mab.inligo.no';

export const CRM_URL = ENV === 'development'
  ? 'http://localhost:3000'
  : ENV === 'staging'
    ? 'https://app.beta.medarbeiderne.no'
    : 'https://app.medarbeiderne.no';

export const STRIPE_PUBLISHABLE_KEY = ENV === 'production'
  ? 'pk_live_2TniWvlLZ20sZ1CcmCQ3jPun' // live, mab account
  : 'pk_test_FcstMA66jp9EH8xkulweArNU'; // test, mab account

export const BACKEND_URL = `${BACKEND_BASE_URL}`;
export const MAB_AUTH_TOKEN = 'mab-auth-token';
export const dateFormat = 'YYYY-MM-DD';

console.log('BACKEND_URL', BACKEND_URL);
console.log('MinSide version', MINSIDE_FRONTEND_VERSION);
console.log('Environment', ENV);
